<script setup lang="ts">
import FooterBottom from '@/components/Footer/FooterBottom.vue'
import FooterMid from '@/components/Footer/FooterMid.vue'
import FooterUpper from '@/components/Footer/FooterUpper.vue'
import { useTrustPilotWidget } from '@/services/seoGlobalService'

useTrustPilotWidget()
</script>

<template>
  <footer
    class="flex flex-col gap-10 md:gap-10 lg:gap-20 bg-black text-white py-5 md:py-12 min-h-[200px] md:min-h-[300px]"
  >
    <FooterUpper></FooterUpper>
    <FooterMid></FooterMid>
    <FooterBottom></FooterBottom>
  </footer>
</template>
